import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, from } from 'apollo-link';
import { onError } from 'apollo-link-error';

const httpLink = new HttpLink({
	uri: process.env.VUE_APP_GRAPHQL_URL,
	credentials: 'include'
});

const errorLink = onError(({ networkError }) => {
	if (
		networkError &&
		networkError.name ==='ServerError' &&
		networkError.statusCode === 401
	) {
		sessionStorage.removeItem('is_auth');
		window.location.href = '/login';
	}
});

const middleware = new ApolloLink((operation, forward) => {
	// Header for login to accept connection before first authorisation
	if (operation && operation.operationName === 'login') {
		operation.setContext({
			headers: { 'login': true }
		});
	}
	return forward(operation);
});

export const apolloClient = new ApolloClient({
	link: from([
		errorLink,
		middleware,
		httpLink,
	]),
	cache: new InMemoryCache(),
	connectToDevTools: true
});

const apolloProvider = new VueApollo({
	defaultClient: apolloClient
});

Vue.use(VueApollo);

export default apolloProvider;